import React, {useEffect} from 'react'
import Header from '../pages/common/Header'
import Footer from '../pages/common/Footer'
import {Outlet, useLocation} from 'react-router-dom'

function MainLayout() {
    const location = useLocation();

    useEffect(() => {
        // 경로가 변경될 때마다 스크롤을 맨 위로 이동
        window.scrollTo(0, 0);
        const element = document.getElementById('menu');
        if (element) {
            element.className = 'background'; // or use element.classList.add('new-class-name') to add a class
        }
        const menuALl = document.getElementById('menu-all');
        if (menuALl) {
            menuALl.className = 'background'; // or use element.classList.add('new-class-name') to add a class
        }
    }, [location]);

    return (
        <>
            <Header isMain={true}></Header>
            <Outlet />
            <Footer></Footer>
        </>
    )
}

export default MainLayout